module.exports = __webpack_public_path__ + "img/hm.a3808757.jpg";